import { createFileRoute } from "@tanstack/react-router";
import { CustomerDetail } from "@/features/customers/customer-detail";

export const Route = createFileRoute("/_authenticated/customers/$workspaceId")({
  component: CustomerDetailPage,
});

function CustomerDetailPage() {
  const { workspaceId } = Route.useParams();
  return <CustomerDetail workspaceId={workspaceId} />;
}
